import { Wrapper, Button } from './styled';
import { useTracking } from 'react-tracking';
import { Heading } from '@simplywallst/ui-core';

interface Props {
  companyName: string;
  canonicalUrl: string;
}

const ResearchSlide = ({ canonicalUrl, companyName }: Props) => {
  const { trackEvent } = useTracking();
  const trackingConfig = {
    type: 'track',
    action: 'click',
  };

  return (
    <Wrapper
      data-cy-id="research-slide"
      as="section"
      templateRows="auto auto"
      alignContent="start"
    >
      <Heading
        as="h3"
        typography="smallStrong"
        color="white"
        textAlign="center"
      >
        Further research on
        <br />
        {companyName}
      </Heading>
      <Button
        data-cy-id="research-slide-button"
        styleType="loudLarge"
        display="block"
        to={`${canonicalUrl}/valuation`}
        onClick={() => {
          trackEvent({
            ...trackingConfig,
            modifier: 'research value',
          });
        }}
      >
        Valuation
      </Button>
      <Button
        data-cy-id="research-slide-button"
        styleType="loudLarge"
        display="block"
        to={`${canonicalUrl}/health`}
        onClick={() => {
          trackEvent({
            ...trackingConfig,
            modifier: 'research health',
          });
        }}
      >
        Financial Health
      </Button>
      <Button
        data-cy-id="research-slide-button"
        styleType="loudLarge"
        display="block"
        to={`${canonicalUrl}/ownership`}
        onClick={() => {
          trackEvent({
            ...trackingConfig,
            modifier: 'research insider trading',
          });
        }}
      >
        Insider Trading
      </Button>
      <Button
        data-cy-id="research-slide-button"
        styleType="loudLarge"
        display="block"
        to={`${canonicalUrl}/management`}
        onClick={() => {
          trackEvent({
            ...trackingConfig,
            modifier: 'research management',
          });
        }}
      >
        Management Team
      </Button>
    </Wrapper>
  );
};

export default ResearchSlide;
